var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.442,
    height: 30.849,
    viewBox: "0 0 26.442 30.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-file-word",
    "data-name": "Icon metro-file-word",
    d: "M27.842,8.745a4.006,4.006,0,0,1,.826,1.308,3.973,3.973,0,0,1,.344,1.515V31.4a1.646,1.646,0,0,1-1.653,1.653H4.223A1.646,1.646,0,0,1,2.571,31.4V3.856A1.646,1.646,0,0,1,4.223,2.2H19.648a3.974,3.974,0,0,1,1.515.344,4.006,4.006,0,0,1,1.308.826ZM20.2,4.545v6.473h6.473a1.881,1.881,0,0,0-.379-.706L20.9,4.923a1.88,1.88,0,0,0-.706-.379Zm6.61,26.3V13.221H19.648a1.646,1.646,0,0,1-1.653-1.653V4.407H4.774V30.849H26.809ZM6.582,15.424v1.842H7.787L10.61,28.645h2.737l2.2-8.349a4.684,4.684,0,0,0,.207-1.205h.069l.052.413a3.345,3.345,0,0,1,.06.344,2.78,2.78,0,0,0,.095.448l2.2,8.349h2.737L23.8,17.266H25V15.424H19.837v1.842h1.549l-1.7,7.54a4.81,4.81,0,0,0-.121.792l-.034.362h-.069l-.052-.362q-.017-.086-.069-.362t-.086-.43l-2.479-9.382H14.81l-2.479,9.382q-.034.155-.077.422t-.06.37l-.069.362h-.069l-.034-.362a4.81,4.81,0,0,0-.121-.792l-1.7-7.54h1.549V15.424H6.582Z",
    transform: "translate(-2.571 -2.203)",
    fill: "#003960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWord);
export default __webpack_public_path__ + "static/media/icon-word.a12a7cbc5eaca2a8f378e4bf88ac1a6b.svg";
export { ForwardRef as ReactComponent };